import { genericPage, getServerSidePropsHelper, getSlugEleccio, getMappingEleccions3CatInfo } from 'components/3catinfo/Page';
import { useRouter } from 'next/router';

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions']);
};

export async function getServerSideProps(context) {
    let { preview } = context.query;
    const slugEleccio = getSlugEleccio(context?.resolvedUrl);
    const mapping = await getMappingEleccions3CatInfo(slugEleccio);
    let estat = preview || 'seo';
    let cisPactometre = false;

    let path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions', slugEleccio, 'pactometre'];

    if (estat === 'escrutini') {
        path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions', slugEleccio, 'pactometre', 'escrutini'];
    } else if (cisPactometre) {
        path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions', slugEleccio, 'pactometre', 'cis'];
    }

    const options = {
        slugs: path,
        id: mapping.id,
        slugEleccio
    };
    return getServerSidePropsHelper(context, options);
}

export default Pagina;
